<template>
  <div class="zee zee-component">
    <a-upload
      v-if="name"
      :action="upUrl"
      :headers="headers"
      :accept="accept"
      :file-list="fileList"
      :before-upload="beforeUpload"
      @change="bindFileUpload"
      @error="handleUploadError"
    >
      <template #default>
        <div v-if="!fileList.length">
          <a-button><icon-upload />上传</a-button>
        </div>
      </template>
    </a-upload>
    <div v-if="uploadError" class="upload-error-message">
      <a-alert message="上传失败" description="文件过大或服务器错误，请重试" type="error" />
    </div>
  </div>
</template>

<script>
const env = require("../../../env/index");
import { IconUpload } from '@arco-design/web-vue/es/icon'

export default {
  name: "FUploadFile",
  components: {
    IconUpload
  },
  props: {
    name: String,
    value: [String, Array], // 2026-1-20 修正上传修改不显示， :file-list="fileList"特别注意
    accept: String,
    maxFileSize: {
      type: Number,
      default: 5 // 默认10MB
    }
  },
  data() {
    return {
      upUrl: env.UPLOAD, // 上传地址
      headers: {
        // Authorization: this.$fan.getdwToken(),
        token: JSON.stringify(
          Object.assign(env.TOKEN, { token: this.$fan.getToken() })
        ),
      },
      fileList: [],
      uploadError: false,
      isUploading: false
    };
  },
  watch: {
    value(newValue) {
      this.fileList = this.initFileList(newValue); // 当value变化时，更新fileList
    },
  },
  created() {
    this.fileList = this.initFileList(this.value);
    // if (this.value && this.value !== '') {
    //   this.fileList = [{
    //     uid: 1,
    //     name: this.value,
    //     thumbUrl: this.value,
    //     status: 'done'
    //   }]
    // }
  },
  methods: {
    initFileList(value) {
      if (Array.isArray(value) && value.length > 0) {
        return value.map((val, index) => ({
          uid: `-${index + 1}`,
          name: val.split('/').pop() || '上传文件',
          url: val,
          status: "done",
        }));
      }
      
      if (typeof value === 'string' && value.trim()) {
        return [{
          uid: '-1',
          name: value.split('/').pop() || '上传文件',
          url: value,
          status: "done",
        }];
      }
      
      return [];
    },
     // 上传前检查文件大小
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024; // MB
      if (fileSize > this.maxFileSize) {
        this.$message.error(`文件大小超过限制（最大${this.maxFileSize}MB）`);
        return false;
      }
      
      this.uploadError = false;
      this.isUploading = true;
      return true;
    },
   bindFileUpload(info, file) {
      this.fileList = info.fileList;
      
      const fileItem = file || info.file;
      if (fileItem.status === "done") {
        this.isUploading = false;
        if (fileItem.response && fileItem.response.data) {
          this.$emit(
            "change",
            this.name,
            fileItem.response.data
            // BASE.picurl + file.response.data[0].filePath
          );
        } else {
          this.uploadError = true;
          const errorMsg = fileItem.response?.msg || '上传失败，请重试';
          this.$message.error(errorMsg);
        }
      } else if (fileItem.status === "error") {
        this.isUploading = false;
        this.uploadError = true;
        this.$message.error('上传失败，请检查网络或文件');
      } else if (fileItem.status === "removed") {
        this.uploadError = false;
        this.$emit("change", this.name, "");
      }
    },
    
    // 处理上传错误
    handleUploadError(err, file) {
      this.isUploading = false;
      this.uploadError = true;
      this.$message.error(`上传失败: ${err.message || '未知错误'}`);
      
      // 更新文件列表状态
      this.fileList = this.fileList.map(item => {
        if (item.uid === file.uid) {
          return { ...item, status: 'error' };
        }
        return item;
      });
    }
  },
};
</script>

<style scoped>
.upload-error-message {
  margin-top: 10px;
}

/* Arco Design upload 样式调整 */
.arco-upload-list-picture-card .arco-upload-list-item-thumbnail,
.arco-upload-list-picture-card .arco-upload-list-item-thumbnail img {
  width: auto !important;
}

/* 上传中状态样式 */
.uploading-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>